import { SupplierContactDataOptional } from '../../components/SupplierContactForm/SupplierContactForm.schema';
import { SvbrgIntakeRequestSupplier, SvbrgIntakeRequestSupplierAddInput, SvbrgLanguage } from '@/generated/gql/graphql';

export const gridDataToSupplier = (
  row: SupplierContactDataOptional,
): Omit<SvbrgIntakeRequestSupplierAddInput, 'chatSessionId'> => {
  const { contact, location } = row.supplier;
  return {
    internalId: row.supplier.internalId,
    isQuoted: true,
    contact: contact
      ? {
          firstName: contact.firstName,
          lastName: contact.lastName,
          email: contact.email,
          internalId: contact.internalId,
          language: contact.language as SvbrgLanguage,
        }
      : undefined,
    location: location
      ? {
          address: location.address,
          city: location.city,
          postalCode: location.postalCode,
          countryCode: location.countryCode,
          internalId: location.internalId,
        }
      : undefined,
  };
};

const hasContactData = (contact: SvbrgIntakeRequestSupplier['contact']): boolean =>
  Boolean(contact.internalId || contact.email || contact.firstName || contact.lastName);

const hasLocationData = (location: SvbrgIntakeRequestSupplier['location']): boolean =>
  Boolean(location.internalId || location.address || location.city || location.postalCode || location.countryCode);

export const apiToSupplier = (supplier: SvbrgIntakeRequestSupplier): SupplierContactDataOptional => {
  return {
    id: supplier.id,
    supplier: {
      internalId: supplier.internalId,
      isQuoted: supplier.isQuoted,
      source: supplier.source || null,
      contact: hasContactData(supplier.contact)
        ? {
            firstName: supplier.contact.firstName || '',
            lastName: supplier.contact.lastName || '',
            email: supplier.contact.email || '',
            internalId: supplier.contact.internalId,
            language: supplier.contact.language || '',
          }
        : null,
      location: hasLocationData(supplier.location)
        ? {
            address: supplier.location.address || null,
            city: supplier.location.city || null,
            postalCode: supplier.location.postalCode || null,
            countryCode: supplier.location.countryCode || null,
            internalId: supplier.location.internalId,
          }
        : null,
    },
  };
};
